import React, { useEffect } from 'react'

// componets
import TermsConditions from '@/components/organisms/TermsConditions/TermsConditions'
import { Footer } from '@/components/organisms/Footer/Footer'
import { Menu } from '@/components/organisms/Menu/Menu'

import Cookies from 'js-cookie'
import { TOKEN, RECOVERY_ADVERTISE } from '@/utils/constants'
import { TermsCondProvider } from '@/context/guest/TermsCond/TermsCondProvider'

import { encrypt } from '@/utils'
import { sweetError } from '@/utils/sweetalert2'
import axios from 'axios'

const Index = ({ tokenGuest }) => {
  useEffect(() => {
    // console.log('tokenGuest', tokenGuest)
    if (!tokenGuest.error && tokenGuest.token) {
      Cookies.set(TOKEN, encrypt(tokenGuest.token))
      Cookies.set(RECOVERY_ADVERTISE, true)
    } else {
      sweetError('', tokenGuest.message)
    }
  }, [tokenGuest])
  return (
    <>
      <Menu />
      <div>
        <TermsCondProvider>
          <TermsConditions />
        </TermsCondProvider>
      </div>
      <Footer />
    </>
  )
}

export async function getServerSideProps () {
  try {
    const baseURL = process.env.API_PASSPORT_URL
    const formData = new FormData()
    formData.append('grant_type', 'client_credentials')
    formData.append('client_id', process.env.CLIENT_ID)
    formData.append('client_secret', process.env.CLIENT_SECRET)
    const response = await axios.post(`${baseURL}/oauth/token`, formData)
    const { access_token: accessToken } = response.data
    return {
      props: {
        tokenGuest: {
          error: false,
          token: accessToken
        }
      }
    }
  } catch (error) {
    return {
      props: {
        tokenGuest: {
          error: true,
          message: error.message
        }
      }
    }
  }
}

export default Index
